//
//  Workspace.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { WorkspaceProfile, } from "./SDKWorkspaceProfile";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class Workspace {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.profile = new WorkspaceProfile(model.profile);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        return {
            id: this.id,
            profile: this.profile.toRemote(),
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using `fromTransport` */
    toTransport() {
        return {
            id: this.id,
            profile: this.profile.toTransport(),
        };
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        return new Workspace(model);
    }
}
